interface ICalcuateData {
  targetNumber: number;
}

/**
 * IQR(Interquartile Range)을 이용하여 이상치를 제거하는 필터 함수
 * @param calcalutedTargetNumbers targetNumber를 포함한 데이터 배열
 * @returns IQR 범위 내의 데이터만 필터링된 배열
 */
export const getIQRBounds = (calcalutedTargetNumbers: ICalcuateData[]): { upperBound: number; lowerBound: number } => {
  if (calcalutedTargetNumbers.length === 0) {
    return { upperBound: 0, lowerBound: 0 };
  }

  // targetNumber 값들만 추출하여 정렬
  const targetNumbers = calcalutedTargetNumbers.map((item) => item.targetNumber).sort((a, b) => a - b);

  const { length } = targetNumbers;

  // Q1 (25%), Q3 (75%) 계산
  const q1Index = Math.floor(length * 0.25);
  const q3Index = Math.floor(length * 0.75);

  const q1 = targetNumbers[q1Index];
  const q3 = targetNumbers[q3Index];

  // IQR 계산
  const iqr = q3 - q1;

  // 이상치 범위 계산 (1.5 * IQR 규칙)
  const lowerBound = Math.abs(q1 - 1.1 * iqr);
  const upperBound = q3 + 1.5 * iqr;

  // IQR 범위 내의 데이터만 필터링
  return { upperBound, lowerBound };
};
